import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import NProgress from 'vue-nprogress';
import { sync } from 'vuex-router-sync';
import VTooltip from 'v-tooltip';

import App from './App.vue';
import router from './router';
import store from './store';
// import * as filters from './filters';

window.Vue = Vue;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Lightbox for images
// https://github.com/silencesys/silentbox
import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox);

Vue.use(VTooltip);

Vue.router = router;
Vue.use(VueAxios, axios);


// Enable devtools
Vue.config.devtools = true;

sync(store, router);

Vue.use(NProgress);
const nprogress = new NProgress({ parent: '.nprogress-container' });

const { state } = store;

// var bus = new Vue();
var transitionName;

router.beforeEach((route, redirect, next) => {
    if (route.meta.transitionName !== undefined) {
        this.transitionName = route.meta.transitionName;
    }
    // console.log('router beforeEach: ' , route, ' redirect: ', redirect.path, 'next: ', next());
    // Set title dinamically
    if (route.meta.title !== undefined) {
        // console.log('Dynamic metatite: ', route.meta.title(route));
        document.title = route.meta.title(route);
    }

    next();
});

window.Vue = Vue;

const app = new Vue({
    el: '#app',
    data: {
        transitionName: transitionName,
    },
    router,
    store,
    nprogress,
    ...App
});




// WEBPACK FOOTER //
// ./src/index.js